import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from "axios";
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const HoldReasonForm = (props) => {

    const [validated, setValidated] = useState(false);
    const initialFormData = {
        holdreason: "",
        isactive: false,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);
    //const navigate = useNavigate();

    useEffect(() => {
        async function setHoldReasonDetails() {
            setFormData({
                holdreason: props.holdreasonvalue.split(",")[0],
                isactive: props.holdreasonvalue.split(",")[1] == 1 ? true : false,
                id: props.holdreasonvalue.split(",")[2]
            });

            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        }

        if (props.edittrigger > 0) {
            setHoldReasonDetails();
        }
    }, [props.edittrigger]);

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");

        let holdReasonUrl = buttonStatus == "Add" ? `${process.env.REACT_APP_SERVER_URL}` + "/drugs/add-hold-reason/" : `${process.env.REACT_APP_SERVER_URL}` + "/drugs/update-hold-reason/";

        let holdReasonData = buttonStatus == "Add" ? { "reason": formData.holdreason,"group_id" : localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0 } : { "reason": formData.holdreason,"group_id" : localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "reason_id": formData.id }

        console.log("holdReasonData" + JSON.stringify(holdReasonData));

        const { data } = await axios.post(holdReasonUrl, holdReasonData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success("Reason added/updated successfully");
        }
        else {
            toast.info("Error while adding/updating Reason");
        }

        //if (props.status != "Edit") {
        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");
        //}

        //if (props.status == "Add")
        props.onCallParent();
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Reason</Form.Label>
                        <Form.Control
                            placeholder='Reason'
                            value={formData.holdreason}
                            name="holdreason"
                            onChange={handleFieldChange}
                            type="text"
                            size="sm"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="w-50 mt-4"
                            disabled={!formData.holdreason}
                            size="sm"
                        >
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={
                                formData.isactive
                            }
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};
export default HoldReasonForm;
